import PropTypes from 'prop-types';
import { useEffect, createContext } from 'react';
// hooks
import useLocalStorage from '../hooks/useLocalStorage';

// ----------------------------------------------------------------------

const initialState = {
  // Client/Site
  client: {},
  site: {},
  siteLocation: {},
  locationPath: 'Browse Locations', // Location browser button uses this variable for its text
  showArchived: false,
  instrumentListColumnVisibility: {
    "__check__": true,
    "id": false,
    "client": false,
    "site": false,
    "tag_number": true,
    "description": true,
    "last_calibration": false,
    "next_calibration": false,
    "type": false,
    "model": true,
    "serial_number": true
  },
  onChangeClient: () => {},
  onChangeSite: () => {},
  onChangeSiteLocation: () => {},
  onChangeLocationPath: () => {},
  onChangeInstrumentColumnVisibility: () => {},
};

const ConfigurationContext = createContext(initialState);

// ----------------------------------------------------------------------

ConfigurationProvider.propTypes = {
  children: PropTypes.node,
};

function ConfigurationProvider({ children }) {
  const [configuration, setConfiguration] = useLocalStorage('configuration', {
    client: initialState.client,
    site: initialState.site,
    siteLocation: initialState.siteLocation,
    locationPath: initialState.locationPath,
    instrumentListColumnVisibility: initialState.instrumentListColumnVisibility,
  });

  const onChangeClient = (client) => {
    setConfiguration({
      ...configuration,
      client,
    });
  };

  const onChangeSite = (site) => {
    setConfiguration({
      ...configuration,
      site,
    });
  };

  const onChangeSiteLocation = (siteLocation, newLocationPath) => {
    setConfiguration({
      ...configuration,
      siteLocation,
      locationPath: newLocationPath || configuration.locationPath,
    });
  };

  const onChangeLocationPath = (locationPath) => {
    setConfiguration({
      ...configuration,
      locationPath,
    });
  };

  const onChangeInstrumentColumnVisibility = (instrumentListColumnVisibility) => {
    setConfiguration({
      ...configuration,
      instrumentListColumnVisibility,
    });
  };

  const onChangeShowArchived = (showArchived) => {
    setConfiguration({
      ...configuration,
      showArchived,
    });
  };

  return (
    <ConfigurationContext.Provider
      value={{
        ...configuration,

        // Client/Site
        onChangeClient,
        onChangeSite,
        onChangeSiteLocation,
        onChangeLocationPath,
        onChangeInstrumentColumnVisibility,
        onChangeShowArchived,
      }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
}

export { ConfigurationProvider, ConfigurationContext };
